import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "icon-chevron",
  viewBox: "0 0 8 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1 14.475a.62.62 0 0 0 .441-.183l5.434-5.434a2.284 2.284 0 0 0 0-3.216L1.44.208a.63.63 0 0 0-.883 0 .63.63 0 0 0 0 .884L5.99 6.525c.4.4.4 1.05 0 1.45L.558 13.408a.63.63 0 0 0 0 .884.66.66 0 0 0 .442.183"
    }, null, -1)
  ]))]))
}
export default { render: render }